export const fullGradient = {
    background: 'linear-gradient(to right, #CDEFFF, #D2C2F9, #FFC5FD)'
}
export const partialGradient1 = {
    background: 'linear-gradient(to right, #CDEFFF, #FFC5FD)'
}
export const partialGradient2 = {
    background: 'linear-gradient(to right, #CDEFFF, #D2C2F9)'
}
export const partialGradient3 = {
    background: 'linear-gradient(to right, #D2C2F9, #FFC5FD)'
}
export const backgroundBlue = {
    background: 'linear-gradient(to right, #CDEFFF)'
}
export const backgroundPurple= {
    background: 'linear-gradient(to right, #D2C2F9)'
}
export const backgroundPink = {
    background: 'linear-gradient(to right, #FFC5FD)'
}
export const iconContainer = {
    fontSize: '32px',
    color: 'black',
    marginLeft: '10px',
    marginRight: '10px',
}